import React from 'react';

const getCaptchaToken = () => {
	if (!window.returnRequestCaptchaSiteKey) return Promise.resolve('');
	if (!window.grecaptcha || !window.grecaptcha.ready)
		return Promise.reject(new Error('Captcha is not available.'));
	return new Promise((resolve, reject) => {
		window.grecaptcha.ready(() => {
			window.grecaptcha.execute(window.returnRequestCaptchaSiteKey, { action: 'returnrequest' })
				.then(token => token ? resolve(token) : reject(new Error('Empty captcha token.')))
				.catch(reject);
		});
	});
};

export default class ReturnRequestIdentifyForm extends React.Component {
	state = {
		email: '',
		orderNumber: '',
		submitting: false,
		error: ''
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const T = window.Texts.returnRequest;
		this.setState({ submitting: true, error: '' });
		getCaptchaToken()
			.then(captchaToken => {
				this.props.onSubmit({
					email: this.state.email,
					orderNumber: this.state.orderNumber,
					captchaToken
				});
			})
			.catch(() => {
				this.setState({ submitting: false, error: T.errorText });
			});
	}

	render() {
		const T = window.Texts.returnRequest;
		return (
			<div className="return-request-identify">
				<div className="cover">
					<div className="headline">
						<h1>{T.step1Title}</h1>
					</div>
					<div className="inner-500">
						<p>{T.step1Desc}</p>
						{this.state.error && (
							<p className="missing-entry"><strong>{this.state.error}</strong></p>
						)}
						<form onSubmit={this.handleSubmit}>
							<div className="box form-box">
								<div className="form-group">
									<label>{T.email}</label>
									<input
										type="email"
										className="form-control"
										required
										value={this.state.email}
										onChange={e => this.setState({ email: e.target.value })}
									/>
								</div>
								<div className="form-group">
									<label>{T.orderNumber}</label>
									<input
										type="text"
										className="form-control"
										required
										value={this.state.orderNumber}
										onChange={e => this.setState({ orderNumber: e.target.value })}
									/>
								</div>
								<button
									type="submit"
									className="btn btn50"
									disabled={this.state.submitting}
								>
									{T.sendBtn}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}
